import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import SvgEdit from 'components/svg/SvgEdit';
import SvgTrash from 'components/svg/SvgTrash';
import WarrantyTableActionItem from './WarrantyTableActionItem';

interface WarrantyTableRowActionsProps {
    id: number;
    onOpen?: (id: number) => void;
    onArchive?: (id: number, archived: boolean) => void;
    archived?: boolean;
    onDelete?: (id: number) => void;
    assigned?: boolean;
    onDetach?: (id: number) => void;
}

const WarrantyTableRowActions = ({ id, onOpen, onDetach, onDelete, onArchive, archived = false, assigned = false }: WarrantyTableRowActionsProps) => {
    const { t } = useTranslation('Warranties');

    if (!onOpen && !onDetach && !onDelete && !onArchive) return null;

    const menu = (
        <Dropdown.Menu
            className="p-2 shadow-sm warehouse-team-menu"
            popperConfig={{ strategy: 'fixed' }}
            renderOnMount
        >
            {onOpen && (
                <WarrantyTableActionItem
                    icon={<SvgEdit />}
                    title={t('rowActions.edit')}
                    description={t('rowActions.editHint')}
                    onClick={() => onOpen(id)}
                />
            )}
            {onArchive && !assigned && (
                <WarrantyTableActionItem
                    icon={<SolarIcon name={archived ? 'check-circle' : 'archive'} />}
                    title={archived ? t('restore') : t('rowActions.archive')}
                    description={t(archived ? 'rowActions.restoreHint' : 'rowActions.archiveHint')}
                    onClick={() => onArchive(id, !archived)}
                />
            )}
            {onDetach && (
                <WarrantyTableActionItem
                    icon={<SolarIcon name="x-circle" />}
                    title={t('detach')}
                    description={t('rowActions.detachHint')}
                    onClick={() => onDetach(id)}
                    danger
                />
            )}
            {onDelete && (
                <>
                    <Dropdown.Divider className="my-2" />
                    <WarrantyTableActionItem
                        icon={<SvgTrash />}
                        title={t('rowActions.delete')}
                        description={assigned ? t('errors.ASSIGNED') : t('rowActions.deleteHint')}
                        onClick={() => onDelete(id)}
                        disabled={assigned}
                        danger
                    />
                </>
            )}
        </Dropdown.Menu>
    );

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                className="p-1 py-0"
                size="sm"
                variant="light-secondary"
                id={`dropdown-warranty-${id}`}
                aria-label={t('fields.actions')}
            >
                <SolarIcon name="three-dots" />
            </Dropdown.Toggle>
            {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
        </Dropdown>
    );
};

export default WarrantyTableRowActions;
